import styled from "styled-components";

export const TableOrderSummary = styled.div`
    padding:  0 24px 24px 24px;
`;